var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-advance-select", {
    attrs: {
      disabled: _vm.disabled,
      "select-type": _vm.selectTypeNames.static_data_Location,
      cache: false,
      filterable: "",
      "default-value": _vm.defaultValue,
      "static-options": _vm.options,
      placeholder: _vm.placeholder || undefined
    },
    on: {
      parentCallBack: function(p) {
        _vm.$emit("change", p)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }